import { localeBetHistoryType } from '../en-US'

export const betHistory: localeBetHistoryType = {
  yourBetSelling: 'Tu apuesta se está vendiendo',
  betHistory: 'Historial de apuestas',
  infoTitle: 'Seleccione pujar a punto para mostrar información detallada .',
  setBet: 'Seleccione una apuesta en la lista de sus apuestas a la izquierda',
  sold: 'Vendido',
  showBets: 'Mostrar apuestas',
  winned: 'Ganancias',
  lossed: 'Pérdidas',
  dateFrom: 'Que data de',
  showSold: 'Vendido',
  betSoldSuccess: 'Venta exitosa',
  freeBetCantSell: 'Las apuestas gratuitas no se pueden vender',
  yes: 'Sí',
  no: 'No',
  sellBet: 'Vender apuesta',
  sell: 'Cobro inmediato',
  cancel: 'Cancelar',
  cantUndone: 'No se puede deshacer.',
  betNotSell: 'La apuesta no está a la venta',
  sureToSell: '¿Realmente querías cobrar esta apuesta',
  for: 'por',
  notCalculated: 'No calculado',
  dateFilter: 'Filtrar por fecha',
  from: 'De',
  to: 'Para',
  show: 'Mostrar',
  date: 'Fecha',
  bet: 'Apuesta',
  outcome: 'Resultado',
  amount: 'Importe',
  coef: 'Impar',
  possibleWin: 'Posible victoria',
  possibilityWin: 'Posibilidad de ganar',
  coefShort: 'Impar',
  possible: 'Posible',
  resultWin: 'Ganado',
  page: 'Página',
  hideFilters: 'Ocultar filtros',
  showFilters: 'Mostrar filtros',
  express: 'Express',
  eventsTypeOne: 'Eventos',
  eventsTypeTwo: 'Eventos',
  eventsTypeThree: 'Eventos',
  startMatch: 'Inicio del partido',
  score: 'Puntuación',
  totalOdds: 'Probabilidades totales',
  type: 'Tipo',
  costWill: 'El valor de su apuesta será:',
  single: 'Soltero',
  overallCoef: 'Coef en general.',
  status: 'Estado',
  of: 'de',
  winnedResult: 'Ganado',
  winAmount: 'Cantidad de ganancias',
  details: 'Detalles',
  view: 'Ver',
  code: 'Código',
  match: 'Partido',
  tourney: 'Torneo',
  filters: 'Filtros',
  pleaseAuth: 'Por favor, auth',
  backToProfile: 'Volver al perfil',
  oddsType: 'Tipo de probabilidades',
  markets: 'Mercados',
  ok: 'OK',
  all: 'Todos',

  close: 'Cerrar',
  confirm: 'Confirmar',
  confQuestion: 'Estás seguro ?',
  cashoutValue: 'Valor de retiro',
  cashout: 'Cobro inmediato',
  showAll: 'Mostrar todo',
  running: 'Corriendo',
  settled: 'Asentado',
  playerActivities: 'Actividades de los jugadores',
  ticketID: 'Identificación del boleto',
  winning: 'Ganador original',
  betslip: 'Boleta de apuestas',
  bets: 'Apuestas',
  bethistoryDetail: 'Detalle del Historial de Apuestas',
  back: 'Atrás',
  odds: 'Probabilidades',
  stake: 'Estaca',
  result: 'Resultado',

  sftBetStatuses: {
    Wait: 'Espera',
    Lost: 'Perdido',
    Return: 'Devuelto',
    Win: 'Ganar',
    CashOut: 'Vendido',
  },
}
